import { PlatformApiEnhancerFunction } from '../../../types/platformApi';
import { translate } from '../../services/translationService';

export const utilsEnhancer: PlatformApiEnhancerFunction = () => {
  return {
    editor: {
      utils: {
        translate,
      },
    },
  };
};
